import { FlexBox, Spacer } from '@airship-platform/jam-web/components';
import AppliedDiscountsList from './AppliedDiscountsList';
import OptionHeader from './OptionHeader';
import OptionModifiers from './OptionModifiers';
import OptionProducts from './OptionProducts';
import OptionSOW from './OptionSOW';

const ProposalOptionsView: React.FC = () => (
  <FlexBox flexDirection={'column'} gap={[2, 4]}>
    <OptionHeader />

    <AppliedDiscountsList />

    <OptionProducts groupingName="SYSTEM" />

    <OptionProducts groupingName="ADDONS" />

    <OptionProducts groupingName="UPGRADES" showAddButton={false} />

    <OptionModifiers />

    <OptionSOW />

    <Spacer height="2rem" />
  </FlexBox>
);

export default ProposalOptionsView;
